import styled from 'styled-components';
import { fontSize } from 'app/shared/styles/_fontsize';

import Text from 'app/shared/core/Text';

export const AreaFacts = styled.article`
  margin-top: 8px;
`;

export const AreaFactsSection = styled.section`
  margin-bottom: 16px;
`;

export const FactHeader = styled(Text)`
  margin-bottom: 4px;
`;

export const FactParagraph = styled(Text)`
  margin-bottom: 8px;
`;

export const FactSubHeader = styled(Text)`
  margin-bottom: 4px;
`;

export const FactUnorderedList = styled.ul`
  font-size: ${fontSize['$font-size-sm']};
  line-height: ${fontSize['$line-height-sm']};
  margin-bottom: 8px;
`;

export const FactOrderedList = styled.ol`
  font-size: ${fontSize['$font-size-sm']};
  line-height: ${fontSize['$line-height-sm']};
  margin-bottom: 8px;
`;
